import React from "react";

const StatusBarView = ({ quote, statuses, children }) => {
  return (
    <div className="status-bar">
      {statuses.map(({ status, label }) => (
        <div key={label} className={`status-bar-item ${status}`}>
          {label}
        </div>
      ))}

      <div key="actions" className="status-bar-actions">
        {children}
      </div>
    </div>
  );
};

export default StatusBarView;
